<template>
  <div class="animated fadeIn mb-4">
    <div ref="report" class="pl-2 py-2">
      <submission-report-header :header="report.header" />
      <submission-western-tractor-report 
        v-if="report_type === 'Potato'"
        :results="report_samples"
      />
      <submission-feed-report
        v-else-if="report_type === 'Feed'"
        :samples="report_samples"
      />
      <submission-mixer-efficiency-report
        v-else-if="report_type === 'Feed Mixer Efficiency'"
        :samples="report_samples"
      />
      <submission-sar-report
        v-else-if="report_type === 'Irrigation Suitability'"
        :samples="report_samples"
      />
      <submission-septic-report
        v-else-if="report_type === 'Septic Soil'"
        :samples="report_samples"
      />
      <submission-tissue-report
        v-else-if="report_type === 'Tissue'"
        :samples="report_samples"
      />
      <submission-water-report
        v-else-if="report_type === 'Water'"
        :samples="report_samples"
      />
      <submission-soil-report v-else-if="report_type === 'Soil'" :results="report_samples" />
      <submission-general-report v-else :samples="report_samples" />
      <submission-report-footer :footer="report.footer" />
    </div>
    <b-button @click="download">Download PDF</b-button>
  </div>
</template>

<script>
import SubmissionFeedReport from "./types/SubmissionFeedReport";
import SubmissionGeneralReport from "./types/SubmissionGeneralReport";
import SubmissionMixerEfficiencyReport from "./types/SubmissionMixerEfficiencyReport";
import SubmissionReportHeader from "./SubmissionReportHeader";
import SubmissionReportFooter from "./SubmissionReportFooter";
import SubmissionSarReport from "./types/SubmissionSarReport";
import SubmissionSepticReport from "./types/SubmissionSepticReport";
import SubmissionTissueReport from "./types/SubmissionTissueReport";
import SubmissionWaterReport from "./types/SubmissionWaterReport";
import SubmissionWesternTractorReport from "./types/SubmissionWesternTractorReport";
import SubmissionSoilReport from './types/SubmissionSoilReport';
import { downloadHtmlCanvas } from '@/shared/utils';

export default {
  name: "SubmissionReport",
  components: {
    SubmissionFeedReport,
    SubmissionGeneralReport,
    SubmissionMixerEfficiencyReport,
    SubmissionReportFooter,
    SubmissionReportHeader,
    SubmissionSarReport,
    SubmissionSepticReport,
    SubmissionTissueReport,
    SubmissionWaterReport,
    SubmissionWesternTractorReport,
    SubmissionSoilReport,
  },
  props: {
    submission: {
      type: Object,
      default: () => null,
    },
    report_type: {
      type: String,
      default: null
    },
    report: {
      type: Object,
      default: () => {
        return {}
      },
    }
  },
  computed: {
    report_samples() {
      return this.report.samples
    }
  },
  methods: {
    download() {
      const { report } = this.$refs;
      const fileName = `${this.report_type}.pdf`;
      downloadHtmlCanvas(report, fileName);
    },
  },
};
</script>
